import { render, staticRenderFns } from "./OneVideo.vue?vue&type=template&id=612e97c4&scoped=true"
import script from "./OneVideo.vue?vue&type=script&lang=js"
export * from "./OneVideo.vue?vue&type=script&lang=js"
import style0 from "./OneVideo.vue?vue&type=style&index=0&id=612e97c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "612e97c4",
  null
  
)

export default component.exports